import type {
  MEMBERSHIP_MODELS,
  PLAYER_PORTALS_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';
import {
  getMappedLinkedItems,
  getFirstMappedLinkedItemOrDefault,
} from './utils/component-mapping-helpers';
import {
  getFirstLinkedAssetOrDefault,
  getFirstLinkedItemOrDefault,
  getColorValue,
  getSingleChoiceValue,
} from '@r-and-a-shared-ui/common-kontent-client/utils';

type CallOutPanelModel = MEMBERSHIP_MODELS.CallOutPanel &
  PLAYER_PORTALS_MODELS.CallOutPanel;

export const call_out_panel = (entry: CallOutPanelModel) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }
  const { elements, system } = entry || {};

  return {
    backgroundImage: getFirstLinkedAssetOrDefault(elements?.background_image)
      ?.url,
    backgroundColor: getColorValue(
      getFirstLinkedItemOrDefault(elements?.background_color),
    ),
    mobileBackgroundImage: getFirstLinkedAssetOrDefault(
      elements?.mobile_background_image,
    )?.url,
    title: elements.title?.value,
    description: elements.description,
    tags: getMappedLinkedItems(elements?.tags),
    link: getFirstMappedLinkedItemOrDefault(elements?.link),
    access: getSingleChoiceValue(
      elements?.membership_based_access__select_access,
    ),
    buttonTitle: elements.button_title?.value,
    icon: {
      url: getFirstLinkedAssetOrDefault(elements?.icon)?.url,
      alt: getFirstLinkedAssetOrDefault(elements?.icon)?.description || '',
    },
    theme: getSingleChoiceValue(elements?.theme),
    kontentItemId: system?.id,
  };
};

export default call_out_panel;
